import React, { Fragment } from "react"
import SbEditable from "storyblok-react"
import Img from "gatsby-image"
import { getFluidGatsbyImage } from 'gatsby-storyblok-image'
import styled from 'styled-components'

const ArticleItemWrapper = styled.div`
  margin-bottom: 40px;
`

const ArticleItem = styled.a`
  display: block;
  border-bottom: 1px solid #30403c;
  height: 100%;
  padding-bottom: 15px;

  .articleItem__image,
  .articleItem__title {
    margin-bottom: 15px;
  }

  .articleItem__tags {
    height: 20px;
  }

  .articleItem__title {
    white-space: pre;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .articleItem__date {
    font-size: 12px;
    letter-spacing: -0.3px;
    color: #e9dccd;
  }

  .articleItem__intro {
    opacity: 0.6;
    height: 60px;
    overflow: hidden;
  }
`
 
const ArticleList = ({ blok }) => {
  console.log(blok.articles)
  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="row">
        {blok.articles.map(article => {
          const featuredImage = getFluidGatsbyImage(article.content.featured_image[0].image.filename, {
            maxWidth: 300,
            maxHeight: 300,
          })
          return (
            <ArticleItemWrapper
              className="col-6 col-md-4"
              key={article.name}
            >
              <ArticleItem href={`/${article.full_slug}`}>
                <Img
                  className="articleItem__image"
                  fluid={featuredImage}
                />
                <div className="articleItem__tags">
                  {article.tag_list.length > 0 ?
                      <span className="gradient-text">
                          {article.tag_list.map((tag, index) =>
                              <Fragment key={index}>{index !== 0 ? `, `: null}{tag}</Fragment>
                          )}
                      </span>
                  : ''}
                </div>
                <div>
                  <h2 className="articleItem__title">{article.content.title}</h2>
                  <p className="articleItem__intro">{article.content.intro}</p>
                </div>
                <div>
                </div>
              </ArticleItem>
            </ArticleItemWrapper>
          )
        })}
      </div>
    </SbEditable>
  )
}
 
export default ArticleList